import { GET } from "../APiHelper/API"

export const getAllOtherNamesSourcesAPICall = (onSucces, onError) => {
    GET("/api/v1/users/all_other_names_sources", onSucces, onError)
}